import { loadStripe } from '@stripe/stripe-js';
import * as Sentry from '@sentry/react';

// Mobile Safari bricht den Request zu js.stripe.com häufig ab (instabiles
// Mobilnetz, ITP/Content-Blocker, Tab im Hintergrund). @stripe/stripe-js setzt
// seinen internen Script-Promise bei einem Fehler auf null zurück, daher startet
// ein erneuter loadStripe-Aufruf das Laden tatsächlich neu.
const loadStripeWithRetry = async (
  key,
  { retries = 3, baseDelay = 1000 } = {},
) => {
  for (let attempt = 0; ; attempt++) {
    try {
      const stripe = await loadStripe(key);
      if (!stripe) {
        throw new Error('Failed to load Stripe.js');
      }
      return stripe;
    } catch (error) {
      if (attempt >= retries) {
        Sentry.captureException(error, { tags: { feature: 'stripe-load' } });
        throw error;
      }
      await new Promise((resolve) =>
        setTimeout(resolve, baseDelay * 2 ** attempt),
      );
    }
  }
};

export default loadStripeWithRetry;
